/** Képek szűrése drag–drop és fájlválasztó esetén (Fotók, Finder, HEIC). */

export function isValidImageFile(fileName: string, fileType: string): boolean {
  if (fileName === ".DS_Store" || fileName.startsWith("._") || fileName.startsWith(".DS_")) {
    return false;
  }
  if (fileName === "Thumbs.db" || fileName === "desktop.ini") {
    return false;
  }
  const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".webp", ".bmp", ".svg", ".heic", ".heif"];
  const lower = fileName.toLowerCase();
  const hasExt = imageExtensions.some((ext) => lower.endsWith(ext));
  const isImageMime = fileType.startsWith("image/");
  return hasExt || isImageMime;
}

export function filterImageFiles(files: Iterable<File>): File[] {
  const out: File[] = [];
  for (const file of files) {
    if (isValidImageFile(file.name, file.type)) out.push(file);
  }
  return out;
}

export function dataTransferHasFilePayload(dt: DataTransfer): boolean {
  try {
    return dt.types?.includes?.("Files") ?? Array.from(dt.types ?? []).includes("Files");
  } catch {
    return false;
  }
}
